import { call, put, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';
import { fetchReasons, fetchedReasons } from './actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';

type FetchActionPayload = ReturnType<typeof fetchReasons>;

export function* getReasonsSaga({ meta: { callback } }: FetchActionPayload) {
  const { getReasons } = getAPI();
  const response: YieldOf<typeof getReasons> = yield call(getReasons);
  const { data = [], ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedReasons(data));
  } else {
    const error = problem || 'unknown';
    yield put(fetchedReasons(undefined, error));
  }

  if (callback) callback();
}

export default function* reasonsSaga() {
  yield takeLatest(fetchReasons.type, getReasonsSaga);
}
